import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Grid, GridItem } from "@sainsburys-tech/fable";
import StoreZoneReviewList from "../StoreZoneReviewList/";
import SendScheduleButton from "../SendScheduleButton/";
import mapSceneLevel from "../../model/store-commissioning/mapSceneLevel";
import getZoneSortIdx from "../../model/store-commissioning/getZoneSortOrder";

class StoreZonesReviewPage extends Component {
  state = {
    shouldRedirectToStorePage: false
  };

  mapReviewItem = (scenes, storeId, zoneDetails) => {
    return {
      storeId: storeId,
      scenes: scenes.map(scene => {
        return {
          levelPercentage: mapSceneLevel(scene),
          name: scene.scene.name,
          description: scene.scene.description
        };
      }),
      zoneId: zoneDetails.zone.zoneId,
      zoneName: zoneDetails.zone.name,
      zoneType: zoneDetails.zone.zoneType,
      luxMeterCbusGroupId: zoneDetails.luxMeterCbusGroupId,
      lightsCbusGroupId: zoneDetails.lightsCbusGroupId,
      hasLuxMeter: zoneDetails.hasLuxMeter,
      pinId: zoneDetails.pinId,
      pirSensorIds: zoneDetails.pirSensorIds
    };
  };

  handleSuccess = () => {
    this.setState({ shouldRedirectToStorePage: true });
  };

  render() {
    const storeZones = this.props.store.zoneConfiguration
      .map((zone, index) => {
        const storeZone = this.props.store.storeConfiguration.zones.find(
          x => x.zone.name === zone.zone.name
        );
        return this.mapReviewItem(
          zone.scenes,
          this.props.store.store.storeId,
          storeZone
        );
      })
      .sort((a, b) => getZoneSortIdx(a.zoneType) - getZoneSortIdx(b.zoneType));

    if (this.state.shouldRedirectToStorePage) {
      return (
        <Redirect
          to={`/stores/${this.props.store.store.storeId}?tab=lighting`}
          push={true}
        />
      );
    }

    return (
      <div>
        <h3>Review zones</h3>
        <section>
          <Grid cols={{ xs: 1, lg: 1 }}>
            <GridItem colSpan={{ xs: 1, lg: 1 }}>
              <Grid cols={{ xs: 1, lg: 2 }}>
                <GridItem colSpan={{ xs: 1, lg: 1 }}>
                  <p>
                    Please review that the zones and their scenes have been
                    correctly created. Also, check that the C-Bus group ID's and
                    Lux sensor details for each zone are correct. If you need to
                    amend anything that appears incorrect, then click on 'Create
                    Zones and Scenes' to go back and change them.
                  </p>
                </GridItem>
              </Grid>
            </GridItem>
            <StoreZoneReviewList
              zones={storeZones}
              setConfirmationDialog={() => this.setConfirmationDialog}
              featureLightingGroupId={
                this.props.store.storeConfiguration.featureLightingGroupId
              }
              counterLightingGroupId={
                this.props.store.storeConfiguration.counterLightingGroupId
              }
            />
          </Grid>
        </section>
        <SendScheduleButton
          label={"Complete commissioning"}
          sendSchedule={() =>
            this.props
              .completeCommissioning(this.props.store.store.storeId)
              .then(response => {
                this.props.onLightingStoresChange();
                return response.revision.scheduleIds[0];
              })
          }
          successMessage={"Acknowledged"}
          pendingMessage={"Pending..."}
          sentMessage={"Sent..."}
          onSuccess={this.handleSuccess}
        />
      </div>
    );
  }
}

export default StoreZonesReviewPage;
